import React, { FC } from "react";

/** Illustration only — text and actions are rendered separately in ErrorFallbackView. */
const ErrorBoundaryIllustration: FC = () => (
  <svg
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    className="app-error-boundary__svg"
  >
    <circle cx="100" cy="100" r="88" fill="#EEF2F7" />
    <ellipse cx="100" cy="168" rx="52" ry="8" fill="#D8E0EA" />

    <rect x="52" y="118" width="72" height="8" rx="4" fill="#1A5F9E" />
    <rect x="48" y="126" width="80" height="28" rx="6" fill="#2B7BB9" />

    <circle cx="88" cy="98" r="14" fill="#F4C9A8" />
    <path
      d="M74 98c0-8 6-14 14-14s14 6 14 14"
      fill="#3D4F63"
    />
    <rect x="80" y="108" width="16" height="14" rx="4" fill="#5B8DEF" />

    <path
      d="M78 86c2-4 6-6 10-6"
      stroke="#94A3B8"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M82 82c1-3 4-5 7-5"
      stroke="#94A3B8"
      strokeWidth="2"
      strokeLinecap="round"
    />

    <rect x="118" y="108" width="22" height="16" rx="2" fill="#CBD5E1" />
    <rect x="120" y="110" width="18" height="10" rx="1" fill="#E2E8F0" />

    <rect x="136" y="92" width="6" height="42" rx="2" fill="#94A3B8" />
    <rect x="128" y="96" width="22" height="5" rx="2" fill="#94A3B8" />
    <rect x="130" y="104" width="18" height="4" rx="2" fill="#94A3B8" />
    <rect x="132" y="112" width="14" height="4" rx="2" fill="#94A3B8" />
    <circle cx="139" cy="86" r="10" fill="#DC2626" />
    <text
      x="139"
      y="90"
      textAnchor="middle"
      fill="#fff"
      fontSize="12"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
    >
      !
    </text>

    <path
      d="M42 132c0-4 2-8 6-10"
      stroke="#64748B"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <ellipse cx="38" cy="138" rx="8" ry="10" fill="#4ADE80" />
    <rect x="36" y="146" width="4" height="8" rx="1" fill="#A16207" />
  </svg>
);

export default ErrorBoundaryIllustration;
